// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + (chunkId === 265 ? "receipt-summary" : chunkId) + ".js?id=" + {"83":"152892b277243f03","121":"7212fc9073fa4587","258":"c087ac596141dd84","265":"c542f2de67e6d3b4","866":"88e8929cab4ac131","888":"f08b85a9eb43706c"}[chunkId] + "";
};